import { Link } from 'react-router-dom';
import useLiterals from 'utils/hooks/useLiterals';
import LogoImg from 'assets/logos/logo.png';
import { ReactComponent as LockIcon } from 'assets/icons/checkout/lock.svg';
import { ROUTE_PATH } from 'routes';

/**
 * Desktop-only checkout header (replaces the app desktop nav during checkout).
 * Fixed, 80px tall; PaymentCheckout styles offset the layout to clear it.
 */
const CheckoutHeader = () => {
  const literals = useLiterals('paymentCheckout');

  return (
    <header className='payment-checkout-header fixed top-0 left-0 z-[100] flex h-20 w-full items-center justify-between border-b border-neutral-200 bg-white px-8'>
      <Link to={ROUTE_PATH.HOME} className='flex items-center'>
        <img src={LogoImg} alt='Platform logo' className='max-h-12 max-w-[200px]' />
      </Link>
      <div className='flex items-center gap-2 text-sm text-neutral-600'>
        <LockIcon aria-hidden='true' className='h-5 w-5' />
        <span>{literals.secureCheckout}</span>
      </div>
    </header>
  );
};

export default CheckoutHeader;
